import { Action } from 'redux'

export const callFetch = <T>(
  fetchName: string,
  reverseName: string,
  cb: (api: GlobalFetch) => T,
): IRequestFetch<T> => ({
  cb,
  reverseType: reverseName,
  type: fetchName,
})

export interface IRequestFetch<T> extends Action<string> {
  reverseType: string
  cb: (api: GlobalFetch) => T
}
